import { CobaltIconCalendarOutline } from '@cae/cobalt-react/icons/outline/CobaltIconCalendarOutline';
import { CobaltIconDocumentOutline } from '@cae/cobalt-react/icons/outline/CobaltIconDocumentOutline';
import { CobaltIconFolderOutline } from '@cae/cobalt-react/icons/outline/CobaltIconFolderOutline';
import { CobaltIconInstructorOutline } from '@cae/cobalt-react/icons/outline/CobaltIconInstructorOutline';
import { CobaltIconTasksOutline } from '@cae/cobalt-react/icons/outline/CobaltIconTasksOutline';
import { CobaltIconUserManagementOutline } from '@cae/cobalt-react/icons/outline/CobaltIconUserManagementOutline';
import { CobaltIconUserOutline } from '@cae/cobalt-react/icons/outline/CobaltIconUserOutline';
import { CobaltIconViewListOutline } from '@cae/cobalt-react/icons/outline/CobaltIconViewListOutline';
import { APP_ROUTES } from '@routes/routes.constants';

import type {
  QuickLinkHeapEvent,
  QuickLinkId,
  QuickLinkItem,
} from './QuickLinks.types';

export const QUICK_LINK_HEAP_EVENTS: Partial<
  Record<QuickLinkId, QuickLinkHeapEvent>
> = {
  'view-reservations': {
    eventName: 'Manage - Home - Click - ViewReservations',
    elementId: 'homeViewReservations',
  },
  'get-latest-records': {
    eventName: 'Manage - Home - Click - GetLatestRecords',
    elementId: 'homeGetLatestRecords',
  },
  'find-an-invoice': {
    eventName: 'Manage - Home - Click - FindAnInvoice',
    elementId: 'homeFindAnInvoice',
  },
  'submit-a-document': {
    eventName: 'Manage - Home - Click - SubmitADocument',
    elementId: 'homeSubmitADocument',
  },
  'manage-users': {
    eventName: 'Manage - Home - Click - ManageUsers',
    elementId: 'homeManageUsers',
  },
};

export const QUICK_LINKS: QuickLinkItem[] = [
  {
    id: 'request-training',
    label: 'Request training',
    icon: CobaltIconCalendarOutline,
    permissions: ['ReservationRequests_Add_Org'],
    route: APP_ROUTES.MANAGE_RESERVATION_REQUESTS_NEW,
  },
  {
    id: 'view-reservations',
    label: 'View reservations',
    icon: CobaltIconViewListOutline,
    permissions: ['Reservations_View_Org'],
    route: APP_ROUTES.MANAGE_RESERVATIONS,
  },
  {
    id: 'get-latest-records',
    label: 'Get latest records',
    icon: CobaltIconTasksOutline,
    permissions: ['Records_View_Org'],
    route: APP_ROUTES.MANAGE_RECORDS,
  },
  {
    id: 'find-an-invoice',
    label: 'Find an invoice',
    icon: CobaltIconDocumentOutline,
    permissions: ['Invoices_View_Org'],
    route: APP_ROUTES.MANAGE_INVOICES_PAYMENTS,
  },
  {
    id: 'submit-a-document',
    label: 'Submit a document',
    icon: CobaltIconFolderOutline,
    permissions: [
      'CustomerTrainingDocuments_Add_Org',
      'SubmittedTrainingDocuments_View_Org',
    ],
    route: APP_ROUTES.MANAGE_DOCUMENTS_SUBMITTED_SUBMIT,
  },
  {
    id: 'view-approved-instructors',
    label: 'View approved instructors',
    icon: CobaltIconInstructorOutline,
    permissions: ['InstructorApproval_View_Org'],
    route: APP_ROUTES.MANAGE_INSTRUCTORS_MANAGEMENT,
    featureFlag: 'instructorManagementV2WebApp',
    requiresPart135: true,
  },
  {
    id: 'manage-users',
    label: 'Manage users',
    icon: CobaltIconUserManagementOutline,
    permissions: ['Users_View_Org'],
    route: APP_ROUTES.MANAGE_USERS,
  },
  {
    id: 'update-your-profile',
    label: 'Update your profile',
    icon: CobaltIconUserOutline,
    permissions: ['ProfilePersonalBasic_FullAccess_Own'],
    route: APP_ROUTES.PROFILE,
  },
];
